import vue from 'vue'

const state = {
  dynamicMenu: vue.ls.get('dynamicMenu'),
};

const getters = {
  dynamicMenu: () => state.dynamicMenu ? state.dynamicMenu : vue.ls.get('dynamicMenu'),
};

const actions = {};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'dynamicMenu') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/dynamic/modules/dynamic.js